import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { ObtenerDatosService } from 'src/app/servicios/datos/obtener-datos/obtener-datos.service';
import { ThemeService } from '../../../../theme/theme.service';

@Component({
  selector: 'app-pregunta-avance-nacional',
  templateUrl: './pregunta-avance-nacional.component.html',
  styleUrls: ['./pregunta-avance-nacional.component.scss']
})
export class PreguntaAvanceNacionalComponent implements OnInit {

  constructor(public _globalService: GlobalesService,public themeService: ThemeService,public obtenerDatosService: ObtenerDatosService,) { }

  Search = "";
  respAvance = "";
  respCorte = "Indica el corte de información que realiza el PREP, éste se actualiza aproximadamente cada %min minutos.";
  

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });
    this.obtenerDatosService.configSubject.subscribe(data =>{
      if (data == null)return;
      this.respAvance = `Muestra el porcentaje de la Participación ciudadana que hasta el momento ha votado; el número y porcentaje de Actas capturadas al momento y la hora del último corte, éste se actualiza aproximadamente cada ${data?.min_actualizacion ?? "15"} minutos.`
      this.respCorte = `Indica el corte de información que realiza el PREP, éste se actualiza aproximadamente cada ${data?.min_ultimo_corte ?? "15"} minutos.`;
    });
  }

}
